import React, { useState,useEffect } from 'react';
import {
    Button,Layout,
    Row,Col,notification,
    Modal,
    Upload,Table} from 'antd';
import { PlusOutlined,WarningOutlined,
    CheckCircleOutlined} from '@ant-design/icons';
import { RootState } from '@/redux';
import HeaderSearch from '@/components/HeaderSearch';
const { Content } = Layout;
import SoilTable from '@/components/SoilTable';
import { useNavigate,useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import type { ColumnsType } from 'antd/es/table';
import {SoilCloseIcon, SoilcreateTemplate,SoiluploadTemplate} from '@/resource/IconComponentSets';
import {
    PlayCircleOutlined,
    UploadOutlined
} from '@ant-design/icons';
import { GetAllTemplateList,UploadTemplate,GetTemplateDetailToView } from '@/util/Request';
import './index.less';
import moment from 'moment';
import { updateSuccessMessage, updateWarningMessage } from '@/redux/reducer/common';
import IF from '@/components/IF';
const SoilAnalyses = () => {
    const [searchParam,setSearchParam] = useState<string>('');
    const {deleteFiled} = useSelector((state: RootState) =>state.commonData);
    const [pageIndex,setpageIndex] = useState<number>(1);
    const [visibleErr,setVisibleErr] = useState(false);
    const [templateUpdateType, setTemplateUpdateType] = useState<'CREATE' | 'UPLOAD'>('CREATE');
    const [lock, setLock] = useState(false);
    const [firstIn, setFirstIn] = useState(true);
    useEffect(() => {
        if (!firstIn) {
            GetAnalyses();
        }
    }, [deleteFiled]);
    const [data,setData] = useState([] as any);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const columns = [
        {
            title: 'Name',
            width:'40%',
            dataIndex: 'quer_name',
            render: (text, record, index) =><div className='default-table-height'><a onClick={
                async e=>{
                    navigate('/viewTemplate',{state:{intTemplateId:record.quer_queryid}});
                }
            }>{text}</a></div>
        },
        {
            title: 'Creation Date',
            dataIndex: 'quer_createdon',
            render: (text:string) => <div>{moment(text).format('DD-MM-YYYY h:mm A')}</div>
        },
    ];
    interface DataType {
        key?: React.Key;
        name?: string;
        age?: number;
        address?: string;
    }
    const columnsErr:ColumnsType<DataType> = [
        {title: 'Profile Code',key: 'soil-profile-code-template', dataIndex: 'profileCode',width:150},
        {title: 'Layer', key: 'soil-layer-template', dataIndex: 'layer',width:120},
        // {title: 'Rank',dataIndex: 'rank',width:70},
        {title: 'Sampling start Depth(cm)', key: 'soil-start-depth-template',dataIndex: 'samplingStartDepth'},
        {title: 'Sampling End Depth(cm)', key: 'soil-end-depth-template',dataIndex: 'samplingEndDepth'},
        {title: 'Sampling Date', key: 'soil-sampling-date-template',dataIndex: 'samplingDate',width:100},
        {title: 'Sampling Code', key: 'soil-sampling-code-template', dataIndex: 'sampleCode',width:150},
        {title: 'Prop Value', key: 'soil-prop-value-template',dataIndex: 'propValue'},
        {title: 'Class', key: 'soil-class-template', dataIndex: 'class'},
        {title: 'Property', key: 'soil-property-template', dataIndex: 'property',width:100},
        {title: 'Estimation Method', key: 'soil-estimation-template', dataIndex: 'method',width:150},
        {title: 'Unit', key: 'soil-unit-template',dataIndex: 'unit'},
        {title: 'error_msg', key: 'soil-error-msg-template',dataIndex: 'errorMsg',width:150,fixed:'right'}
    ];
    useEffect(() => {
        GetAnalyses();
    }, []);
    const [visible, setVisible] = useState(false);
    const [dataError,setDataError] = useState([]);
    const GetAnalyses = async (param=searchParam,page=pageIndex)=>{
        try {
            if(lock) {
                return;
            }
            setLock(true);
            setSearchParam(param);
            const res = await GetAllTemplateList({
                searchStr:param,
                pageIndex:1,
                pageSize:15*page
            });
            setData(res);
            setIsFetching(false);
            setLock(false);

            if (firstIn) {
                setFirstIn(false);
            }
        } catch (err) {
            if (firstIn) {
                setFirstIn(false);
            }
            setIsFetching(false);
        }
    };

    const beforeUpload = async (file)=>{
        console.log(file);
        // const fom = new FormData();
        // fom.append('file',file);
        try{
            dispatch({type:'common/updateShowLoading',payload:true});
            const res = await UploadTemplate({file:file});
            console.log(res);
            // const res = await UploadTemplate({file:file});
            if(res.data.status == 200){
                dispatch({type:'common/updateShowLoading',payload:false});
                // notification.open({
                //     duration: 3,
                //     message:res.data.message,
                //     icon: <CheckCircleOutlined style={{ color: '#19A04B' }} />
                // });
                dispatch(updateSuccessMessage(res.data.message));
            }else{
                dispatch({type:'common/updateShowLoading',payload:false});
                if(res.data.status == 204){
                    console.log(res);
                    setDataError(res.data.message);
                    setVisibleErr(true);
                    setVisible(false);
                }else{
                    // notification.open({
                    //     duration: 3,
                    //     message: res.data.message,
                    //     icon: <WarningOutlined style={{ color: '#E99921' }} />
                    // });
                    dispatch(updateWarningMessage(res.data.message));
                }
            }
        }catch(e:any){
            console.log(e);
            dispatch({type:'common/updateShowLoading',payload:false});
            // notification.open({
            //     duration: 3,
            //     message:e,
            //     icon: <CheckCircleOutlined style={{ color: '#19A04B' }} />
            // });
            dispatch(updateSuccessMessage(e));
        }
        return false;
    };

    const [isFetching, setIsFetching] = useState(false);
    useEffect(() => {
        window.addEventListener('scroll', () => handleScroll());
        return () => window.removeEventListener('scroll', () => handleScroll());
    }, []);
    const handleScroll = () => {
        if (window.innerHeight + document.documentElement.scrollTop > document.body.scrollHeight - 50 ) {
            // console.log('fech more items',pageIndex);
            setIsFetching(true);
        } else {
            // console.log('unreach');
        }
    };
    useEffect(() => {
        if (!isFetching) return;
        setpageIndex(pageIndex+1);
        GetAnalyses(searchParam,pageIndex+1);
    }, [isFetching]);
    return (
        <div className="soil-tempalte-update">
            <h3 className="soliHeader">Templates
                {/* <InfoCircleOutlined style={{margin:'5px 0 0 10px'}} /> */}
            </h3>
            <Row>
                <Col span={16}>
                    <HeaderSearch GetAnalyses={GetAnalyses} placeholder='Search'/>
                </Col>
                <Col span={8}>
                    <Row>
                        <Col span={12}>
                            <h3 className="tableBox" style={{justifyContent:'flex-end'}}>
                                <Button
                                    shape="round"
                                    size='large'
                                    className='soil-button'
                                    style={{background:'#59B948',color:'#fff'}}
                                    icon={ <PlusOutlined /> } onClick={() => {
                                        // setVisible(true);
                                        // setTemplateUpdateType('CREATE');
                                        navigate('/newTemplateUpdate',{});
                                        dispatch({
                                            type: 'common/closeDownFile'
                                        });
                                    }}>
                                    New Template
                                </Button>
                            </h3>
                        </Col>
                        <Col span={12}>
                            <h3 className="tableBox" style={{justifyContent:'flex-end'}}>
                                <Upload
                                    beforeUpload={beforeUpload}
                                    showUploadList={false}
                                    accept=".xlsx"
                                >

                                    {/* <p className="icon"><UploadOutlined /></p>
                                <Upload {...props} style={{margin:'0 auto'}}>
                                    <Button>Upload file...</Button>
                                </Upload> */}
                                    {/* <p className="icon"><SoiluploadTemplate /></p> */}
                                    <Button
                                        shape="round"
                                        size='large'
                                        className='soil-button'
                                        style={{background:'#59B948',color:'#fff'}}
                                        icon={ <PlusOutlined /> } onClick={() => {
                                        // setVisible(true);
                                        // setTemplateUpdateType('UPLOAD');

                                            dispatch({
                                                type: 'common/closeDownFile'
                                            });
                                        }}>
                                        Upload Template
                                    </Button>
                                </Upload>
                            </h3>
                        </Col>

                    </Row>
                </Col>
            </Row>

            <div className="tableBox">
                <Content style={{ backgroundColor: '#fff' }}>
                    <SoilTable
                        rowKey={(record:any) => {
                            return record?.quer_queryid;
                        }}
                        columns={columns}
                        dataSource={data}
                        pagination={false}
                    />
                </Content>
            </div>
            <Modal
                title="Error Message"
                width={'950px'}
                open={visibleErr}
                onCancel={e=>setVisibleErr(false)}
                footer={
                    <Button type="default" shape="round" onClick={e=>setVisibleErr(false)}>
                        Cancel
                    </Button>
                }
                closeIcon={<SoilCloseIcon />}
            >
                <div style={{width:'100%',position:'relative'}}>
                    <h4 className='blod'
                        style={{
                            background: '#DFE2E7',
                            textAlign:'center',
                            borderRadius:'8px 8px 0 0',
                            padding:'3px 0',
                            width:'100%'
                        }}
                    >Invalid Data</h4>
                    <Table
                        rowKey={(record:any) => {
                            console.log('record:============', record);
                            return record?.quer_queryid;
                        }}
                        scroll={{ x: 1600 }}
                        columns={columnsErr}
                        dataSource={dataError}
                        pagination={false}
                    />
                </div>
            </Modal>
            <Modal
                title={templateUpdateType === "CREATE"? "New Template":"Upload Template"}
                open={visible}
                className="downLoadBtn"
                onCancel={e=>setVisible(false)}
                width="490px"
                closable={false}
                mask={false}
                style={{marginRight:21,top:50,borderRadius:16,height:295,background:'#fff'}}
                footer={
                    <Button type="default" shape="round" size='large' onClick={e=>setVisible(false)}>
                        Cancel
                    </Button>
                }
            >
                <div className="template">
                    <div className="template">
                        <IF show={templateUpdateType === 'CREATE'}>
                            <div className="btns" onClick={e=>navigate('/newTemplateUpdate',{})}>
                                <p className="icon"><SoilcreateTemplate /></p>
                                <p className="text" style={{paddingTop:21}}>Create manually</p>
                            </div>
                        </IF>
                        <IF show={templateUpdateType === 'UPLOAD'}>
                            <Upload
                                className="btns"
                                beforeUpload={beforeUpload}
                                showUploadList={false}
                                accept=".xlsx"
                            >
                                <div style={{width:'100%',padding:'0 60px'}}>
                                    {/* <p className="icon"><UploadOutlined /></p>
                                <Upload {...props} style={{margin:'0 auto'}}>
                                    <Button>Upload file...</Button>
                                </Upload> */}
                                    <p className="icon"><SoiluploadTemplate /></p>
                                    <p className="text" style={{paddingTop:21}}>Upload file...</p>
                                </div>
                            </Upload>
                        </IF>
                        {/* <div style={{width:16}}></div> */}
                    </div>
                </div>
            </Modal>
        </div>
    );
};
export default SoilAnalyses;